import './style.scss';
import * as React from "react";
import { connect } from "react-redux";
import { logout, refreshUserAction, refreshToken } from "../../store/actions";
import logo from '../../assets/images/logo.png'
import adminLogo from '../../assets/images/admin-logo.svg'
import bellIcon from '../../assets/images/bell-icon.png'
import menuCollapse from '../../assets/images/Icon ionic-ios-menu.png'
// ui imports
import { bindActionCreators } from "redux";
import SessionTimeout from './SessionTimeout';
import { editClientData } from '../../store/actions';

function HeaderView(props) {

  const adminCompany = props.UserReducer.companyDetails?.companyType === 'Admin';
  const logout = ($e) => {
    props.logout();
    if (adminCompany) {
      props.history.replace('/admin/login')
    } else {
      props.history.replace('/login')
    }
  };

  return (
    <header className="row align-items-center fixed-header">
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex align-items-center">
          <div className="logo_outer">
            {adminCompany ? <img src={adminLogo} alt="" className="logo" /> : <img src={logo} alt="" className="logo" />}
          </div>
          <div className="menuCollapse" onClick={props.clickHeader}>
            <img src={menuCollapse} alt="" className="menuCollapse-icon" />
          </div>
          {(props.UserReducer.LOGIN_AS) && (

            <span className="companyShortName"><b>{props.UserReducer.company}</b> - {props.UserReducer.companyName}</span>
          )}
        </div>
        <div className="d-flex align-items-center">
          <div className="notification-box">
            <img src={bellIcon} alt="" />
          </div>
          <div className="user-image">
            <button className="btn logout_btn" onClick={logout}>Log Out</button>
          </div>
        </div>
      </div>
      <SessionTimeout logout={logout} />
    </header>
  );
}

const mapStateToProps = ({ UserReducer, ClientDataReducer, UserErrorReducer }) => ({ UserReducer, ClientDataReducer, UserErrorReducer });
const mapDispatchToProps = dispatch => (
  bindActionCreators({
    logout,
    editClientData,
    refreshUserAction,
    refreshToken,
  }, dispatch)
);
export default connect(mapStateToProps, mapDispatchToProps)(HeaderView)
